import type { RelationClass } from "../types";

export const RELATION_CLASS_LABELS: Record<RelationClass, string> = {
  Applicant: "Employee",
  SpouseOrDependentAdult: "Spouse / Dependent Adult",
  Child: "Child",
};
